import { render, staticRenderFns } from "./RemoveColumn.vue?vue&type=template&id=1641da8a&"
import script from "./RemoveColumn.vue?vue&type=script&lang=js&"
export * from "./RemoveColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports